import { Component } from 'react';
import { captureReaderAnchor } from '../../hooks/useArticleWindow';

// React takes this snapshot immediately before changing the DOM. A position
// saved in a scroll handler can already be one wheel movement out of date.
export default class ArticleScrollAnchor extends Component {
    getSnapshotBeforeUpdate(previousProps) {
        const previousFirst = previousProps.indices[0];
        const nextFirst = this.props.indices[0];
        const cacheChanged = previousFirst !== nextFirst;
        const rangeChanged = previousProps.rangeStart !== this.props.rangeStart || previousProps.rangeEnd !== this.props.rangeEnd;
        if (!cacheChanged && !rangeChanged) return null;
        const anchor = captureReaderAnchor(this.props.containerRef.current);
        return anchor && this.props.indices.includes(anchor.index) ? { anchor, cacheChanged } : null;
    }

    componentDidUpdate(previousProps, previousState, snapshot) {
        if (snapshot) this.props.onRestore(snapshot.anchor, snapshot.cacheChanged);
    }

    render() {
        return this.props.children;
    }
}
